import { userManifestApi } from '../../api/userManifestApi'

import { addNotification } from './notificationActions'

import { userManifestSignal, userManifestLoadedSignal, userManifestErrorSignal } from '../signals/userManifestSignals'

export const fetchUserManifestByAccessToken = async (config, accessToken) => {
    userManifestLoadedSignal.value = false
    userManifestSignal.value = null
    return await userManifestApi.fetchUserManifestByAccessToken(config, accessToken).then(
        (userManifest) => {
            userManifestSignal.value = userManifest
            userManifestLoadedSignal.value = true
            return userManifestSignal.value
        }
    ).catch(
        (err) => {
            userManifestErrorSignal.value = err
            console.log(err)
            addNotification(`Unable to load user manifest: ${err}`)
        }
    )
}